/** 方案日期：界面 yyyy-MM-dd，后端 routine_year / scheme_year 仍存年份 */

export function todayDateStr() {
  return new Date().toISOString().slice(0, 10)
}

export function yearFromDateStr(d) {
  const y = parseInt(String(d || '').slice(0, 4), 10)
  return y > 0 ? y : new Date().getFullYear()
}

/** 仅有年份时，结合委托日期拼出可展示的完整日期 */
export function deriveSchemeDate(year, refDate) {
  const y = parseInt(year, 10)
  const validYear = y > 0 ? y : new Date().getFullYear()
  const ref = String(refDate || '').slice(0, 10)
  if (ref && yearFromDateStr(ref) === validYear) return ref
  return `${validYear}-01-01`
}

/** 列表里只有 scheme_year 时，格式化为 yyyy-MM-dd 展示 */
export function yearOnlyToDisplayDate(y) {
  const n = parseInt(y, 10)
  if (!n || n <= 0) return '未标'
  return `${n}-01-01`
}

export function normalizeSchemeDateStr(v, fallback) {
  const s = String(v || '').slice(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s
  return fallback || todayDateStr()
}
